module.exports = __webpack_public_path__ + "img/sort-down-solid.cc204b0f.svg";